var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{staticClass:"search",attrs:{"type":"text","placeholder":"Filter","prefix-icon":"el-icon-search"},on:{"change":_vm.updateList,"input":_vm.updateList},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a1542f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filters/Filter.vue
// module id = null
// module chunks = 